import React from "react";
import {observer, inject} from "mobx-react";
import {Route, Switch} from 'react-router-dom';
import { ThemeProvider } from "@octane/spark";
import {Container} from "react-bootstrap";

import {ServerError} from "../../components/interstitials";
import {withRideOctaneTitle, PageTitles} from "../../pages/octane-title";
import {startWidgetMessageListener} from '../utils/widget';
import {CampingWorldFlowStore} from "./camping-world-flow-store";
import {CampingWorldPrequalStep} from "../steps/camping-world-prequal-step";
import {Offers} from "../../prequal/offers";
import {ReturnToServer} from "../../components/return-to-server";

export const CampingWorldFlow = inject(
        'rideOctaneStore',
        'apiStore',
        'userStore',
        'themeStore',
        'partnerStore',
        'historyStore',
        'dealershipStore',
        'uxCopyStore'
    )(
    observer(
        class _CampingWorldFlow extends React.Component {
            store = new CampingWorldFlowStore(this.props);

            componentDidMount() {
                if (this.store.isPartnerDealerWidgetExperience && !this.store.isVehicleSelfSelectionExperience) {
                    const stores = {
                        partnerStore: this.store.partnerStore,
                        dealershipStore: this.store.dealershipStore,
                        historyStore: this.store.historyStore,
                    }
                    const onWidgetTimeout = () => this.store.showServerErrorView("Widget Error.");
                    const onWidgetSuccess = () => this.store.initializeVehicleConfiguration();

                    startWidgetMessageListener(window, stores, onWidgetTimeout, onWidgetSuccess);
                } else {
                    this.store.initializeVehicleConfiguration();
                }
            }

            render() {
                if (this.store.showServerError) {
                    return (
                    <Container data-oid="lcamping-world-prequal-flow-error-page">
                        <ServerError
                            origin="camping-world-prequal-flow"
                            errorMessage={this.store.serverErrorMessage}
                        />
                    </Container>
                    );
                }

                const longPrequalTitle = this.store.isCoapplicantFlow ?
                                    PageTitles.CAMPING_WORLD_COAPPLICANT_TITLE :
                                    PageTitles.CAMPING_WORLD_TITLE;
                const titleWords = this.store.displayVehicle ? [this.store.displayVehicle.name] : [];
                const theme = this.props.themeStore.buildSparkTheme();

                return (
                    <ThemeProvider theme={theme}>
                    <div>
                        <Switch>
                            <Route exact path={["/:slug?/apply", "/:slug?/apply/coapplicant"]}>
                                {withRideOctaneTitle(
                                    <CampingWorldPrequalStep
                                        match={this.props.match}
                                        hasFetchedVehicle={this.store.hasFetchedVehicle}
                                        vehicleConfiguration={this.store.displayVehicle}
                                        isDummyVehicleEnabled={this.store.isDummyVehicleEnabled}
                                        rawVehicleData={this.store.rawVehicleData}
                                        isCoapplicantFlow={this.store.isCoapplicantFlow}
                                        flowStore={this.store}
                                    />, [...titleWords, longPrequalTitle]
                                )}
                            </Route>
                            <Route exact path={["/:slug?/apply/offers/:appUuid", "/:slug?/apply/offers/:appUuid/:applicantUuid"]}>
                                {withRideOctaneTitle(
                                    <Offers
                                        applicationUuid={this.store.applicationUuid}
                                        applicantUuid={this.store.primaryApplicantUuid}
                                        hasCompletedAboutYouForm={this.store.hasCompletedCWPrequalForm}
                                        hasSubmittedSSN={this.store.hasCompletedCWPrequalForm}
                                        aboutYouPrequalUrl={this.store.getPrequalUrl()}
                                        ssnRequiredUrl={null}
                                        isApplicantCMPFlow={!!this.store.primaryApplicantUuid}
                                        accessoriesAmount={this.store.accessoriesAmount}
                                        vehicleConfiguration={this.store.displayVehicle}
                                        offersEndpoint={`/api/v2/applications/${this.store.applicationUuid}/`}
                                    />,
                                    [...titleWords, PageTitles.OFFERS_TITLE]
                                )}
                            </Route>
                            <Route component={ReturnToServer} />
                        </Switch>
                    </div>
                    </ThemeProvider>
                );
            }
        }
    )
);
